import { PropertyStatsDataAdapter } from 'common/data/property/stats/data-adapter';
import { configGetCountry } from 'common/helper/config/get-country';

export function PropertyStatsDataAdapterFactory(): PropertyStatsDataAdapter {
  return new PropertyStatsDataAdapter(configGetCountry());
}
